import React, {
  useState,
  useRef,
  useCallback,
  createContext,
  useMemo,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import Select from "react-select";
import {
  Button,
  Card,
  Typography,
  Stack,
  Box,
  Tooltip,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SourceIcon from "@mui/icons-material/Source";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import AgGridTable from "../utilities/AgGridTable";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import Document from "./Document";
import customStyles from "app/shared-components/SelectCustomStyle";
import InvoiceTable from "./InvoiceTable";
import TourReco from "./TourReco";
import moment from "moment";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ActualContainerType, ContainerStatus, CustomTextEditor, LoadingDate, ETDDate, ETADate } from "./celleditor-component/EditorCoponent";
import  StatusBar  from "./statusbar-panel/StatusBar";



let weekOption = [];
for (let i = 1; i <= 52; i++) {
  weekOption.push({ label: i });
}

const invoiceTypeOptions = [
  { value: "Custom Invoice", label: "Custom Invoice" },
  { value: "Commercial Invoice", label: "Commercial Invoice" },
];

const DocumentContext = createContext();
const InvoiceTableContext = createContext();
const ForwardInfoContext = createContext();
const TourRecoContext = createContext();

const Logistic = () => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlans}`;
  const actualContainer = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.actualContainer}`;
  const containersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containers}`;
  const getForwarderInfoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getForwarderInfo}`;

  const gridRef = useRef();
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [selectedLogisticRows, setSelectedLogisticRows] = useState([]);
  const [successMsg, setSuccessMsg] = useState();
  const perPage = 20;
  const [gridApi, setGridApi] = useState(null);
  const [documentDialog, setDocumentDialog] = useState(false);
  const [tourReco, setTourReco] = useState(false);
  const [rowData, setRowData] = useState();
  const [snackState, setSnackState] = useState(false);
  const [showInvoiceTable, setShowInvoiceTable] = useState(false);
  const [tourWeek, setTourWeek] = useState();
  const [currentWeek, setCurrentWeek] = useState();
  const [plannedWeek, setPlannedWeek] = useState();
  const [ppwDropdownVisible, setPpwDropdownVisible] = useState(false);
  const [cpwDropdownVisible, setCpwDropdownVisible] = useState(false);
  const [tpwDropdownVisible, setTpwDropdownVisible] = useState(false);
  const [saveDisable, setsaveDisable] = useState(true);
  const [rowEvent, setRowEvent] = useState("");
  const [updateRowData, setUpdateRowData] = useState([]);
  const [openUploadDocDialog, setUploadDocDialog] = useState(false);
  const [containerId, setContainerId] = useState("");

  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "action",
      checkboxSelection: true,
      headerTooltip: "Action",
      editable: false,
    },
    {
      field: "containerNo",
      cellRenderer: "agGroupCellRenderer",
      headerName: "Internal Container No",
      headerTooltip: "Internal Container No",
      editable: false,
    },
    {
      field: "logisticStatus",
      cellEditor:ContainerStatus,
      cellStyle: { 'backgroundColor': '#2f765f' },
      headerName: "Container Status",
      minWidth: 250
    },
    {
      field: "shippingType",
      headerTooltip: "Mode Of Shipment",
      editable: false,
      minWidth: 150,
    },
    {
      field: "plannedLoadingWeek",
      headerTooltip: "Planned Week",
      editable: false,
    },
    {
      field: "country",
      headerTooltip: "Country",
      editable: false,
      minWidth: 150
    },
    {
      field: "plannedContainerType",
      headerTooltip: "Planned Container Type",
      editable: false,
      cellRenderer: (props) => { 
        return props?.data?.plannedContainerType?.name    
      },
      minWidth: 180,
    },
    {
      field: "giNk",
      headerTooltip: "Country",
      headerName: "GI EK",
      editable: false,
      minWidth: 80,
    },
    {
      field: "giEk",
      headerTooltip: "Country",
      headerName: "GI NK",
      editable: false,
      minWidth: 120,
    },
    {
      field: "nk",
      headerName: "NK",
      headerTooltip: "NK",
      editable: false,
      minWidth: 120,
      cellRenderer: (props) => {
        const value = props?.data?.vendorViseVolume?.NK
        if (!value) {
          return 0;
        } else {
          return new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 3,
            minimumFractionDigits: 3,
          }).format(props?.data?.vendorViseVolume?.NK);
        }
      },
    },
    {
      field: "ek",
      headerName: "EK",
      headerTooltip: "EK",
      editable: false,
      minWidth: 80,
      cellRenderer: (props) => {
        const value = props?.data?.vendorViseVolume?.EK
        if (!value) {
          return 0;
        } else {
          return new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 3,
            minimumFractionDigits: 3,
          }).format(props?.data?.vendorViseVolume?.EK);
        }
      },
    },
    {
      field: "totalVolume",
      headerTooltip: "Total Volume",
      editable: false,
      minWidth: 150,
      cellRenderer: (props) => {
        const value = props?.data?.totalVolume
        if (!value) {
          return 0;
        } else {
          return new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 3,
            minimumFractionDigits: 3,
          }).format(props?.data?.totalVolume);
        }
      },
    },
    {
      field: "standardVolume",
      headerTooltip: "Standard Volume",
      editable: false,
      minWidth: 150,
    },
    {
      field: "differenceVolume",
      headerTooltip: "Difference Volume",
      editable: false,
      minWidth: 150,
    },
    {
      field: "actualContainerType",
      cellRenderer: (props) =>
        props?.data?.actualContainerType?.name
          ? props?.data?.actualContainerType?.name
          : props?.data?.actualContainerType,
      headerTooltip: "Actual Container Type",
      minWidth: 150,
      cellEditor: ActualContainerType,
      cellStyle: { 'backgroundColor': '#2f765f' },
    },
    {
      field: "tourNo",
      headerTooltip: "Tour No",
      cellEditor: CustomTextEditor,
      cellStyle: { 'backgroundColor': '#2f765f' },
      minWidth: 150,
    },
    {
      field: "lcNumber",
      headerName: "LC Number",
      headerTooltip: "LC Number",
      editable: false,
      minWidth: 150,
    },
    {
      field: "vesselNo",
      headerName: "Vessel No (Api)",
      headerTooltip: "Vessel No (Api)",
      cellEditor: CustomTextEditor,
      cellStyle: { 'backgroundColor': '#2f765f' },
      minWidth: 150,
    },
    {
      field: "actualLoadingDate",
      headerTooltip: "Actual Loading Date",
      cellEditor: LoadingDate,
      cellRenderer: handleDateFormat,
      minWidth: 200,
      cellStyle: { 'backgroundColor': '#2f765f' },
    },
    {
      field: "actualContainerNumber",
      headerTooltip: "Actual Container Number",
      cellEditor: CustomTextEditor,
      cellStyle: { 'backgroundColor': '#2f765f' },
      minWidth: 150,
    },
    {
      field: "orderTotalNoOfPacks",
      headerTooltip: "No of Packs",
      headerName: "No of Packs",
      cellEditor: CustomTextEditor,
      minWidth: 150,
      cellStyle: { 'backgroundColor': '#2f765f' },
    },
    {
      field: "orderTotalWeight",
      headerTooltip: "Weight",
      headerName: "Weight",
      cellEditor: CustomTextEditor,
      minWidth: 150,
      cellStyle: { 'backgroundColor': '#2f765f' },
    },
    {
      field: "etd",
      headerTooltip: "ETD",
      headerName: "ETD",
      cellEditor: ETDDate,
      minWidth: 150,
      cellRenderer: handleDateFormat,
      cellStyle: { 'backgroundColor': '#2f765f' },
    },
    {
      field: "eta",
      headerTooltip: "ETA",
      headerName: "ETA",
      cellEditor: ETADate,
      minWidth: 150,
      cellRenderer: handleDateFormat,
      cellStyle: { 'backgroundColor': '#2f765f' },
    },
    {
      field: "containerAttachment",
      // cellEditor: dowloadDocument,
      cellRenderer: openDocDialog,
      headerName: "Document Upload",
      headerTooltip: "Document Upload",
      editable: false,
      minWidth: 200,
    },
    {
      field: "factoryPictureOfLoadedContainer",
      headerName: "Factory Picture Of The Loaded Container",
      headerTooltip: "Factory Picture Of The Loaded Container",
      editable: false,
      minWidth: 300,
    },
    {
      field: "containerPicFromLoadingCenter",
      headerName: "Customer Picture Of The Loaded Container",
      headerTooltip: "Customer Picture Of The Loaded Container",
      editable: false,
      minWidth: 300,
    },
    {
      field: "containerAttachments",
      headerTooltip: "Document Status",
      headerName: "Document Status",
      editable: false,
      cellRenderer: Status,
      minWidth: 150,
    },
    {
      field: "remark",
      headerTooltip: "Remark",
      cellEditor: CustomTextEditor,
      cellStyle: { 'backgroundColor': '#2f765f' },
      minWidth: 150,
    },
    {
      field: "actualCntrTypeId",
      hide: true,
    },
    { field: "file", hide: true },
  ]);

  function openDocDialog(props) {
    const fileDownload = (id) => {
      setUploadDocDialog(true);
      setDocumentDialog(true);
      setContainerId(id);
    };
    return (
      <div className="flex justify-center">
        <button onClick={() => fileDownload(props.data.id)}>
          <SourceIcon fontSize={'small'} color="warning" />
        </button>
      </div>
    );
  }

  function Status(props) {
    if (props?.data?.containerAttachments?.length === 0) {
      return (
        <p className="text-center">
          <CancelIcon fontSize="small" color="error" />
        </p>
      );
    } 
    else if (props?.data?.logisticStatus === "Document_Upload_In_Progress") {
      return (
        <p className="text-center">
          <WarningIcon color="warning" />
        </p>
      );
    } else if (props?.data?.logisticStatus === "Document_Upload_Completed") {
      return (
        <p className="text-center">
          <CheckCircleIcon color="success" />
        </p>
      );
    }
  }

  const getCurrentWeek = (currentDate) => {
    currentDate.setMonth(0, 1);
    const dayOfWeek = currentDate.getDay();
    const offset = dayOfWeek > 0 ? 8 - dayOfWeek : 1;
    const daysPassed = Math.floor(
      (new Date() - currentDate) / (24 * 60 * 60 * 1000)
    );
    const currentWeek = Math.ceil((daysPassed + offset) / 7);
    console.log('currentWeek', currentWeek)
    setCurrentWeek(currentWeek);
    setPlannedWeek(currentWeek + 1);
    if (currentWeek === 1) {
      setTourWeek(1);
    }else{
      setTourWeek(currentWeek - 3);
    }
    return currentWeek;
  };

  useEffect(() => {
    getCurrentWeek(new Date());
  }, []);


  // Get container clickeking on card

  const submitTPW = async () => {
    const value = { tourPlanningWeek: tourWeek };
    const containers = await OAuthService.addData(containersUrl, value);
    if (containers.data.length === 0) {
      toast.error("No records Found");
    }
    autoSizeAll(false);
    console.log('containers.data.content', containers.data.content)
    setRowData(containers.data.content);
  };
  const submitCPW = async () => {
    const value = { currentProductionWeek: currentWeek };
    const containers = await OAuthService.addData(containersUrl, value);
    if (containers.data.length === 0) {
      toast.error("No records Found");
    }
    autoSizeAll(false);
    setRowData(containers.data.content);
  };
  const submitPPW = async () => {
    const value = { plannedProductionWeek: plannedWeek };
    const containers = await OAuthService.addData(containersUrl, value);
    if (containers.data.length === 0) {
      toast.error("No records Found");
    }
    autoSizeAll(false);
    setRowData(containers.data.content);
  };

  const autoSizeAll = useCallback(
    (value) => {
      const allColumnIds = [];
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
    },
    [rowData]
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
    autoSizeAll(false);
  }, []);

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        rowSelection: "multiple",
        enableRangeSelection: true,
        pagination: true,
        rowGroupPanelShow: "always",
        paginationPageSize: 10,
        columnDefs: [
          { field: "abNumber", headerName: "AB Number" },
          { field: "commissionName" },
          {
            field: "volume",
            // cellRenderer: (props) => {
            //   return new Intl.NumberFormat("en-US", {
            //     maximumFractionDigits: 3,
            //     minimumFractionDigits: 3,
            //   }).format(props?.data?.volume);
            // },
            aggFunc: 'sum'
          },
          { field: "noOfPacks", headerName: "No of Packs", aggFunc: 'sum' },
          { field: "weight", headerName: "Weight (kg)", aggFunc: 'sum' },
        ],
        defaultColDef: {
          floatingFilter: true,
          filter: "agMultiColumnFilter",
          flex: 1,
          editable: false,
          enableRowGroup: true,
          cellStyle: { borderRight: "1px solid #757575" },
        },
        groupIncludeTotalFooter:true,
        // statusBar : {
        //   statusPanels: [
        //     {
        //       statusPanel: StatusBar,
        //     },
        //   ],
        // }
      },
      getDetailRowData: (params) => {
        const covertToNumber = params.data.orders.map((item)=>{
          console.log('item.volume', item.volume)
          // item.volume = parseFloat((item.volume).replace(/,/g, ""));
          // return item;
        })
        params.successCallback(params.data.orders);
      },
    };
  }, []);

  const isRowMaster = useMemo(() => {
    return (dataItem) => {
      return dataItem ? dataItem.orders?.length > 0 : false;
    };
  }, []);

  const onSelectionLogisticChanged = (params) => {
    setSelectedLogisticRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {};

  const isRowSelectable = useMemo(() => {
    return (rowNode) => {
      return rowNode.data ? true : false;
    };
  }, []);

  const handleTourWeekChange = (data) => {
    const currentWeek = getCurrentWeek(new Date());
    const difference = currentWeek - 4;

    if (data.label >= difference && data.label <= currentWeek) {
      setCurrentWeek(currentWeek);
    } else {
      setCurrentWeek("-");
    }
    setTourWeek(data.label);
    setTpwDropdownVisible(false);
  };

  const handleCurrentWeekChange = (data) => {
    if (data.label <= 3) {
      setTourWeek(1);
    } else {
      setTourWeek(data.label - 3);
    }
    if (data.label === 52) {
      setPlannedWeek(data.label);
    }
    setCurrentWeek(data.label);
    setCpwDropdownVisible(false);
  };

  const handlePlannedWeekChange = (data) => {
    const currentWeek = getCurrentWeek(new Date());
    const difference = currentWeek + 4;

    // if (data.label >= currentWeek && data.label <= difference) {
    //   setCurrentWeek(currentWeek);
    // } else {
    //   setCurrentWeek("-");
    // }
    if (data.label <= 4) {
      setTourWeek(1);
    } else {
      setTourWeek(data.label - 4);
    }
    setPlannedWeek(data.label);
    setPpwDropdownVisible(false);
  };

  useEffect(() => {
    if (selectedLogisticRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedLogisticRows]);

  // const onBtAdd = useCallback((event) => {
  //   const newRow = {};
  //   const newRowDate = gridRef.current.api.applyTransaction({
  //     add: [newRow],
  //   });
  //   const RowIndex = newRowDate.add[0].rowIndex;
  //   // updateData.splice(RowIndex, 0, newRow);
  //   gridRef.current.api.refreshCells();

  //   setTimeout(() => {
  //     gridRef.current.api.setFocusedCell(RowIndex, "actualContainerType");
  //     gridRef.current.api.startEditingCell({
  //       rowIndex: RowIndex,
  //       colKey: "actualContainerType",
  //     });
  //   }, 800);
  // }, []);

  const onBtStartEditing = useCallback((event) => {
    const index = event.node.rowIndex;
    gridRef.current.api.setFocusedCell(index, "actualContainerType");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "actualContainerType",
    });
  }, []);

  const getContextMenuItems = (event) => {
    setRowEvent(event);
    var result = [
      // {
      //   name: "Add Row",
      //   icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
      //   action: () => {
      //     onBtAdd(event);
      //   },
      // },
      {
        name: "Edit Row",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: () => {
          onBtStartEditing(event);
        },
      },
      {
        name: "Delete Row",
        // disabled: requireDocument.includes(data.documentName),
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          // onBtDeleteRow(event);
        },
      },
    ];
    return result;
  };

  const onRowValueChanged = useCallback(
    async (event) => {
      let data = event.data;
      const model = {
        id: data.id,
        logisticStatus : data.logisticStatus,
        vesselNo: data.vesselNo,
        actualLoadingDate: data.actualLoadingDate,
        actualContainerNumber: data.actualContainerNumber,
        tourNo: data.tourNo,
        noOfPacks: data.noOfPacks,
        weight: data.weight,
        eta: data.eta,
        etd: data.etd,
        remark: data.remark,
        actualCntrTypeId: data.actualCntrTypeId,
      };
      if (
        updateRowData.filter((data) => data.id === event.data.id).length > 0
      ) {
        const updatedData = updateRowData.map((item) => {
          if (item.id === event.data.id) {
            item.logisticStatus = data.logisticStatus,
            item.tourNo= data.tourNo,
            item.vesselNo = data.vesselNo;
            item.actualLoadingDate = data.actualLoadingDate;
            item.actualContainerNumber= data.actualContainerNumber,
            item.noOfPacks= data.noOfPacks,
            item.weight= data.weight,
            item.eta= data.eta,
            item.etd= data.etd,
            item.remark = data.remark;
          }
          return item;
        });
        setUpdateRowData(updatedData);
      } else {
        setUpdateRowData([...updateRowData, model]);
      }
    },
    [updateRowData]
  );


  useEffect(() => {
    if (updateRowData.length > 0) {
      setsaveDisable(false);
    }
  }, [updateRowData]);

  const headerInputFields = () => {

  // Get All container

  // const createDataSource = () => {
  //   return {
  //     getRows: async (params) => {
  //       const perPage = 20;
  //       const page = Math.floor(params.endRow / perPage) + 1;
  //       try {
  //         const value = { pageNo: page, pageSize: perPage };
  //         const list = await OAuthService.addData(containersUrl, value);
  //         const containers = list.data.content;
  //         params.successCallback(containers, list.data.totalElements);
  //       } catch (error) {
  //         params.failCallback();
  //         // Handle error appropriately
  //         console.error(error.message);
  //       }
  //       return 0;
  //     },
  //   };
  // };

  // const loadContainer = () => {
  //   const dataSource = createDataSource();
  //   console.log('dataSource()', dataSource);
  //   gridApi.setDatasource(dataSource);
  // };

  const loadContainer = async() => {
    try {
      const value = { };
      const list = await OAuthService.addData(containersUrl, value);
      const containers = list.data.content;
      setRowData(containers);
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleSubmit = async () => {
    // setCheckSubmit(true);
    try {
      updateRowData.map(async (data) => { 
          const actualContainerTypeLink = `${actualContainer}/${data.actualCntrTypeId}`;
          const actualContainerType =  data.actualCntrTypeId ? actualContainerTypeLink : "" ;
          const model = {
            logisticStatus : data.logisticStatus,
            vesselNo: data.vesselNo,
            actualLoadingDate: data.actualLoadingDate,
            actualContainerNumber: data.actualContainerNumber,
            tourNo: data.tourNo,
            noOfPacks: data.noOfPacks,
            weight: data.weight,
            eta: data.eta,
            etd: data.etd,
            remark: data.remark,
          };
          const newModel = data.actualCntrTypeId ? {...model, actualContainerType} : model
          const res = await OAuthService.updateData(url, data.id, newModel);
          if (res.status === 200){
            loadContainer();
            setUpdateRowData([]);
            toast.success("Data Updated Successfully");
          }else{
            toast.error("Somethingwent wrong !");
          }
       
        // setSuccessMsg("Data Updated Successfully");
      });
    } catch (error) {
      setError(error.message);
    }
  };

  const requestForForwarder = async()=>{
    try {
      const selectedContainerNo = selectedLogisticRows.map((row)=> row.id);
      const res = await OAuthService.addData(getForwarderInfoUrl, selectedContainerNo);
      if(res.status === 200){
        toast.success("Mail Sent");
      }
    } catch (error) {
      toast.error("Somthing went wrong");
      // setError(error.message);
    }
  }

  useEffect(() => {
    if (gridApi) {
      console.log('UseEffect')
      loadContainer();
    }
  }, [gridApi])
  

    return (
      <>
        <Tooltip title={"Load Default Container"}>
          <Button
            variant="contained"
            color="warning"
            style={{ marginLeft: "4px" }}
            onClick={loadContainer}
          >
            <FuseSvgIcon>heroicons-outline:refresh</FuseSvgIcon>
          </Button>
        </Tooltip>

        <Tooltip title={"Save"}>
          <Button
            type="submit"
            onClick={handleSubmit}
            variant="contained"
            color="warning"
            disabled={saveDisable}
          >
            <FuseSvgIcon>heroicons-solid:archive</FuseSvgIcon>
          </Button>
        </Tooltip>

        <Button
          variant="contained"
          color="warning"
          className="mb-16 mr-3"
          onClick={() => setShowInvoiceTable(true)}
          disabled={selectedLogisticRows.length === 1 ? false : true }
        >
          Document Creation
        </Button>

        <Button
          variant="contained"
          color="warning"
          className="mb-16"
          onClick={() => setDocumentDialog(true)}
          disabled={selectedLogisticRows.length === 1 ? false : true }
        >
          Documents
        </Button>

        <Button
          variant="contained"
          color="warning"
          className="mb-16"
          disabled={deleteDisable}
          onClick={requestForForwarder}
        >
          Request for Forwarder Info
        </Button>

        <Button
          variant="contained"
          color="warning"
          className="mb-16"
          onClick={() => setTourReco(true)}
        >
          Tour Planning Reco
        </Button>
      </>
    );
  };

  return (
    <>
      <div className="flex flex-col items-center px-24 sm:px-40">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-32 md:gap-y-0 md:gap-x-24 w-full max-w-sm md:max-w-4xl my-10">
          <Card className="relative flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden transition-shadow ease-in-out duration-150">
            <div className="flex flex-col flex-auto items-center justify-center p-24 text-center bg-gray-300 ">
              <div className="text-3xl font-semibold text-indigo-800">TPW</div>
              {/* <div className="md:max-w-180 mt-4">(Tour Planning Week)</div> */}
              <div
                className="h-[55px] mt-5"
                onMouseEnter={() => setTpwDropdownVisible(true)}
                onMouseLeave={() => setTpwDropdownVisible(false)}
                onBlur={() => setTpwDropdownVisible(false)}
              >
                {tpwDropdownVisible ? (
                  <Stack className="items-center">
                    <Select
                      className="w-[100px]"
                      menuPosition="fixed"
                      name="tourWeek"
                      menuIsOpen={true}
                      value={
                        tourWeek &&
                        weekOption &&
                        weekOption.filter((obj) => tourWeek === obj.label)
                      }
                      options={weekOption}
                      onChange={handleTourWeekChange}
                      styles={customStyles("#283593", "", "", "#f57c00")}
                    />
                  </Stack>
                ) : (
                  <Typography className="text-center text-4xl font-bold text-indigo-800">
                    {tourWeek}
                  </Typography>
                )}
              </div>
            </div>
            <Box
              onClick={submitTPW}
              className="flex items-center justify-center py-16 px-32 cursor-pointer border rounded-b-2xl border-indigo-50"
            >
              <Typography sx={{ color: "#ffa726" }} className="mx-8">
                Tour Planning Week
              </Typography>
            </Box>
          </Card>

          <Card className="relative flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden transition-shadow ease-in-out duration-150">
            <div className="flex flex-col flex-auto items-center justify-center p-24 text-center bg-gray-300">
              <div className="text-3xl font-semibold text-green-800">CPW</div>
              <div
                className="h-[55px] mt-5"
                onMouseEnter={() => setCpwDropdownVisible(true)}
                onMouseLeave={() => setCpwDropdownVisible(false)}
                onBlur={() => setCpwDropdownVisible(false)}
              >
                {cpwDropdownVisible ? (
                  <Stack className="items-center">
                    <Select
                      className="w-[100px]"
                      menuPosition="fixed"
                      name="currentWeek"
                      value={
                        currentWeek &&
                        weekOption &&
                        weekOption.filter((obj) => currentWeek === obj.label)
                      }
                      options={weekOption}
                      onChange={handleCurrentWeekChange}
                      styles={customStyles("#2E7D32", "", "", "#f57c00")}
                    />
                  </Stack>
                ) : (
                  <Typography className="text-center text-4xl font-bold text-green-800">
                    {currentWeek}
                  </Typography>
                )}
              </div>
            </div>
            <Box
              onClick={submitCPW}
              className="flex items-center justify-center py-16 px-32 cursor-pointer border rounded-b-2xl border-green-50"
            >
              <Typography sx={{ color: "#ffa726" }} className="mx-8">
                Current Production Week
              </Typography>
            </Box>
          </Card>

          <Card className="relative flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden transition-shadow ease-in-out duration-150">
            <div className="flex flex-col flex-auto items-center justify-center p-24 text-center bg-gray-300">
              <div className="text-3xl font-semibold text-pink-800">PPW</div>
              <div
                className="h-[55px] mt-5"
                onMouseEnter={() => setPpwDropdownVisible(true)}
                onMouseLeave={() => setPpwDropdownVisible(false)}
                onBlur={() => setPpwDropdownVisible(false)}
              >
                {ppwDropdownVisible ? (
                  <Stack className="items-center">
                    <Select
                      className="w-[100px]"
                      menuPosition="fixed"
                      name="plannedWeek"
                      value={
                        plannedWeek &&
                        weekOption &&
                        weekOption.filter((obj) => plannedWeek === obj.label)
                      }
                      options={weekOption}
                      onChange={handlePlannedWeekChange}
                      styles={customStyles("#AD1457", "", "", "#f57c00")}
                    />
                  </Stack>
                ) : (
                  <Typography className="text-center text-4xl font-bold text-pink-800">
                    {plannedWeek}
                  </Typography>
                )}
              </div>
            </div>
            <Box
              onClick={submitPPW}
              className="flex items-center justify-center py-16 px-32 cursor-pointer border rounded-b-2xl border-pink-50"
            >
              <Typography sx={{ color: "#ffa726" }} className="mx-8">
                Planned Production Week
              </Typography>
            </Box>
          </Card>
        </div>
      </div>
      <div style={{ zIndex: 0 }}>
        <ListPageHeader
          componentName="Logistics"
          headerInputFields={headerInputFields()}
          pageName="Logistics"
          error={error}
          successMsg={successMsg}
          // gridRef={gridRef}
          pagination={false}
          snackState={snackState}
        />
      </div>
      <div className="h-full">
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionLogisticChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          detailCellRendererParams={detailCellRendererParams}
          masterDetail={true}
          isRowMaster={isRowMaster}
          gridRef={gridRef}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={"LogisticsList"}
          hideCheckbox={true}
          groupCheckBox={true}
          editable={true}
          enableRowGroup={true}
          editType={"fullRow"}
          // rowSelection={'single'}
          autoGroupField={"slNo"}
          isRowSelectable={isRowSelectable}
          onRowValueChanged={onRowValueChanged}
          pagination={false}
          // rowModelType={'infinite'}
          // getContextMenuItems={getContextMenuItems}
        />
      </div>

      <DocumentContext.Provider
        value={[
          documentDialog,
          setDocumentDialog,
          openUploadDocDialog,
          selectedLogisticRows,
          containerId,
        ]}
      >
        {documentDialog && <Document />}
      </DocumentContext.Provider>
      <InvoiceTableContext.Provider
        value={[showInvoiceTable, setShowInvoiceTable]}
      >
        <InvoiceTable selectedLogisticRows={selectedLogisticRows} />
      </InvoiceTableContext.Provider>
      <TourRecoContext.Provider value={[tourReco, setTourReco]}>
        <TourReco />
      </TourRecoContext.Provider>
    </>
  );
};

export default Logistic;
export {
  DocumentContext,
  InvoiceTableContext,
  ForwardInfoContext,
  TourRecoContext,
};
